import * as React from 'react';

function ImagePlaceholder(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="69" height="62" viewBox="0 0 69 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_14427_87742)">
        <path
          d="M52.9062 9H16.9062C13.625 9 10.9062 11.7188 10.9062 15V45C10.9062 48.375 13.625 51 16.9062 51H52.9062C56.1875 51 58.9062 48.375 58.9062 45V15C58.9062 11.7188 56.2812 9 52.9062 9ZM21.4062 15C23.8438 15 25.9062 17.0625 25.9062 19.5C25.9062 22.0312 23.9375 24 21.4062 24C18.7812 24 16.9062 22.0312 16.9062 19.5C16.9062 17.0625 18.9688 15 21.4062 15ZM52.8125 44.25C52.5312 44.7188 51.9688 45 51.5 45H18.6875C18.0312 45 17.5625 44.7188 17.2812 44.25C17.0938 43.6875 17.0938 43.125 17.4688 42.6562L24.0312 33.6562C24.3125 33.2812 24.6875 33 25.25 33C25.7188 33 26.0938 33.2812 26.375 33.6562L29.4688 37.875L38.1875 24.75C38.4688 24.2812 38.9375 24 39.5 24C39.9688 24 40.4375 24.2812 40.7188 24.75L52.7188 42.75C53 43.125 53 43.7812 52.8125 44.25Z"
          fill="#828282"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_14427_87742"
          x="0.90625"
          y="0"
          width="68"
          height="62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14427_87742" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14427_87742" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default ImagePlaceholder;
